"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFastregFormFields = exports.saveValuesToCookies = exports.FirstTouchTracking = exports.firstTouchTracking = exports.SERVICE_FORMS_SELECTOR = exports.FIRST_PAGE_COOKIE_NAME = exports.REFERRER_COOKIE_NAME = void 0;
const cookie_1 = require("./cookie");
const dom_helpers_1 = require("./dom-helpers");
exports.REFERRER_COOKIE_NAME = 'first_touch_referrer';
exports.FIRST_PAGE_COOKIE_NAME = 'first_touch_page';
exports.SERVICE_FORMS_SELECTOR = `form[action*="unregordershortform"],
    form[action*="regForBuyFinishedWork"],
    form[data-first-touch]`;
const COOKIES_MAX_AGE = 3600 * 24 * 365;
function firstTouchTracking({ shouldAddFormFields = true } = {}) {
    const { ref, page } = saveValuesToCookies();
    if (shouldAddFormFields) {
        addFastregFormFields(ref, page);
    }
}
exports.firstTouchTracking = firstTouchTracking;
exports.FirstTouchTracking = firstTouchTracking;
function saveValuesToCookies() {
    let currentRef = (0, cookie_1.getCookie)(exports.REFERRER_COOKIE_NAME);
    let currentPage = (0, cookie_1.getCookie)(exports.FIRST_PAGE_COOKIE_NAME);
    if (typeof currentRef === 'undefined') {
        currentRef = document.referrer;
        (0, cookie_1.setCookieWithDomain)(exports.REFERRER_COOKIE_NAME, currentRef, { 'max-age': COOKIES_MAX_AGE });
    }
    if (typeof currentPage === 'undefined') {
        const { origin, pathname } = document.location;
        currentPage = origin + pathname;
        (0, cookie_1.setCookieWithDomain)(exports.FIRST_PAGE_COOKIE_NAME, currentPage, { 'max-age': COOKIES_MAX_AGE });
    }
    return {
        page: currentPage,
        ref: currentRef,
    };
}
exports.saveValuesToCookies = saveValuesToCookies;
function addFastregFormFields(ref, page) {
    const serviceForms = Array.from(document.querySelectorAll(exports.SERVICE_FORMS_SELECTOR));
    serviceForms.forEach(form => {
        form.appendChild((0, dom_helpers_1.createHiddenInput)(exports.REFERRER_COOKIE_NAME, ref));
        form.appendChild((0, dom_helpers_1.createHiddenInput)(exports.FIRST_PAGE_COOKIE_NAME, page));
    });
}
exports.addFastregFormFields = addFastregFormFields;
